const zh_hant = {
  btn: "登 錄",
  aria_account_placeholder: "輸入電郵",
  account_tips: "未輸入賬號",
  password_tips: "未輸入密碼",
  aria_password_placeholder: "輸入密碼",
  login_fail_message: "未正確填寫賬號或密碼",
  error: "帳號或密碼錯誤",
  remember: "記住密碼",
  forgot: "忘記密碼?",
  title: "教師後台管理系統",
  studentTitle: "學生端帳號登錄",
  institutionsTitle: "機構賬號登錄",
  signUp: "註冊賬號",
  register: "免費註冊",
  home: "首頁",
  welcome: "歡迎您",
  wait: "請稍等片刻...",
  uploadImgFailed: "上傳圖片失敗",
  customerType: "用戶類型",
  ordinaryUsers: "普通用户",
  courseEditor: "課程編輯",
  back: "返回",
  continueRegister: "繼續注册",
  RedemptionCodeError: "兌換碼錯誤，是否繼續注册？",
  teacher: "教師",
  student: "學生",
  changeLoginType: "學校管理員登錄",
  institutions: "機構"
};

const zh_cn = {
  btn: "登录",
  aria_account_placeholder: "输入邮箱",
  account_tips: "未输入账号",
  password_tips: "未输入密码",
  aria_password_placeholder: "输入密码",
  login_fail_message: "未正确填写账号或密码",
  error: "账号或密码错误",
  remember: "记住密码",
  forgot: "忘记密码?",
  title: "教师后台管理系统",
  studentTitle: "学生端账号登录",
  institutionsTitle: "机构账号登录",
  signUp: "注册账号",
  register: "免费注册",
  home: "首页",
  welcome: "欢迎您",
  wait: "请稍等片刻...",
  uploadImgFailed: "上传图片失败",
  customerType: "用户类型",
  ordinaryUsers: "普通用户",
  courseEditor: "课程编辑",
  back: "返回",
  continueRegister: "继续注册",
  RedemptionCodeError: "兑换码错误，是否继续注册？",
  teacher: "教师",
  student: "学生",
  changeLoginType: "学校管理员登录",
  institutions: "机构"
};
const en = {
  btn: "Sign in",
  aria_account_placeholder: "Mail",
  aria_password_placeholder: "Password",
  account_tips: "Cannot be empty",
  password_tips: "Cannot be empty",
  login_fail_message: "Verification failed",
  remember: "Remember",
  error: "Incorrect account or password",
  forgot: "Forget the password?",
  title: "Teacher backend management system",
  studentTitle: "Student account login",
  institutionsTitle: "Institutional account login",
  register: "Sign up",
  signUp: "Sign up",
  home: "Home",
  welcome: "Welcome",
  wait: "Please wait...",
  uploadImgFailed: "Image upload failed",
  customerType: "Customer type",
  ordinaryUsers: "Ordinary users",
  courseEditor: "Course Editor",
  back: "Back",
  continueRegister: "Continuing",
  RedemptionCodeError: "Redemption code error, do you want to continue registering？",
  teacher: "Teacher",
  student: "Student",
  changeLoginType: "School administrator login",
  institutions: "Institutions"
};

const es = {
  btn: "Iniciar sesión",
  aria_account_placeholder: "Dirección de correo electrónico",
  account_tips: "El nombre de la cuenta no puede estar vacío",
  password_tips: "La contraseña no puede estar vacía",
  aria_password_placeholder: "Contraseña",
  login_fail_message: "Verificación fallida",
  error: "Cuenta o contraseña incorrecta ",
  remember: "Recordar",
  forgot: "¿Olvidaste la contraseña?",
  title: "Sistema de gestión para profesores",
  studentTitle: "Iniciar sesión de estudiantes",
  institutionsTitle: "Inicio de sesión de cuentas institucionales",
  signUp: "Registrarse",
  register: "Regístrate gratis",
  home: "Inicio",
  welcome: "Bienvenido/a",
  wait: "Por favor, espera...",
  uploadImgFailed: "Falló la carga de la imagen",
  customerType: "Tipo de usuario",
  ordinaryUsers: "Usuarios comunes",
  courseEditor: "Edición del curso",
  back: "Volver",
  continueRegister: "Continuar",
  RedemptionCodeError: "¿El Código de cambio es incorrecto, ¿ continúa registrándose?",
  teacher: "Profesor",
  student: "Estudiante",
  changeLoginType: "Inicio de sesión del administrador escolar",
  institutions: "Instituciones"
};

export default {
  zh_hant,
  en,
  es,
  zh_cn
};
